import WinData from '../components/WinData';
import EventWrapper from '../utils/EventWrapper';
import ParallelActions from '../utils/ParallelActions';

export default class LineBehavior {
	constructor(scene, linesController, lineData, lineButton, number, color) {
		this.scene = scene;
		this.isSelected = false;
		this.lineData = lineData; // windows numbers
		this.isWinningLine = false;
		this.linesController = linesController;
		this.wonSpins = 0;
		this.wonCoins = 0;
		this.lineButton = lineButton; // optional
		this.changeSelectionEvents = [];
		this.win = null;
		this.number = number;
		this.timeoutID = -1;
		this.winTimeoutID = -1;
		this.flTimerId = -1;
		this.isVisible = false;
		this.color = color;
		this.create();
	}

	create() {
		this.graphics = this.scene.add.graphics();
		this.graphics.depth = 20;
		this.graphics.lineStyle(8, this.color, 1);
		this.linePoints = [];
		for (var i = 0; i < this.lineData.length; i++) {
			this.linePoints.push(this.linesController.reels[i].getWindowPosition(this.lineData[i]));
		}
		for (var i = 0; i < this.linePoints.length - 1; i++) {
			var p1 = this.linePoints[i];
			var p2 = this.linePoints[i + 1];
			this.lineSegment = this.graphics.lineBetween(p1.x, p1.y, p2.x, p2.y);
		}
		if (this.lineButton != null) this.lineButton.addPointerDownEvent(this.buttonClickHandler, this);

		this.setLineVisible(false);
	}

	select(burn) {
		this.isSelected = true;
		this.lineBurn(burn);
		if (this.lineButton != null) {
			this.lineButton.setState(true);
		}
		this.changeSelectionEvents.forEach(eW => {
			if (eW != null && eW.action != null) eW.action.call(eW.context, true);
		});
	}

	deselect() {
		this.isSelected = false;
		this.lineBurn(false);
		if (this.lineButton != null) {
			this.lineButton.setState(false);
		}
		this.changeSelectionEvents.forEach(eW => {
			if (eW != null && eW.action != null) eW.action.call(eW.context, false);
		});
	}

	setLineVisible(visible) {
		this.graphics.setVisible(visible);
		this.isVisible = visible;
	}

	// show the line briefly
	lineBurn(burn) {
		if (!burn) {
			if (this.timeoutID !== -1) {
				clearTimeout(this.timeoutID);
			}
			this.setLineVisible(false);
		} else {
			if (this.timeoutID !== -1) {
				clearTimeout(this.timeoutID);
			}
			this.setLineVisible(true);
			this.timeoutID = setTimeout(() => {
				this.setLineVisible(false);
			}, 1000);
		}
	}

	lineFlashing(flashing) {
		if (flashing && this.flTimerId === -1) {
			this.flTimerId = setInterval(() => {
				this.setLineVisible(!this.isVisible);
			}, 1000);
		} else if (flashing) {
			// flashing already started
		} // cancel flashing
		else {
			clearInterval(this.flTimerId);
			this.flTimerId = -1;
		}
	}

	// Find  and fill winning symbols list  from left to right, according pay lines
	findWin(payTable) {
		this.win = null;
		payTable.forEach(item => {
			// find max win (or win with max symbols count)
			var winTemp = this.getPayLineWin(item);
			if (winTemp != null) {
				if (this.win == null) {
					this.win = winTemp;
				} else {
					if (this.win.Pay < winTemp.Pay || this.win.FreeSpins < winTemp.FreeSpins) {
						this.win = winTemp;
					}
				}
			}
		});
	}

	//Check if line is wonn, according payline
	getPayLineWin(payLine) {
		if (payLine == null) return null;
		var winSymbols = [];
		for (var i = 0; i < this.lineData.length; i++) {
			var s = this.linesController.reels[i].getWindowSymbol(this.lineData[i]);
			if (payLine.line[i] !== 'any' && s.sprite.name !== payLine.line[i]) {
				return null;
			} else if (payLine.line[i] !== 'any' && s.sprite.name === payLine.line[i]) {
				winSymbols.push(s);
			}
		}
		return new WinData(winSymbols, payLine.freeSpins, payLine.pay);
	}

	// Reset old winnig data
	resetLineWinning() {
		this.win = null;
	}

	buttonClickHandler() {
		this.linesController.lineButton_Click(this);
		this.scene.soundController.playClip('button_click');
		console.log('click line button: ' + this.number);
	}

	addChangeSelectionEvent(action, context) {
		if (action != null) this.changeSelectionEvents.push(new EventWrapper(action, context));
	}

	lineWinPlay(playTime, completeCallBack) {
		let isWinTweenComplete = false;
		if (this.win === null || this.win.symbols === null) {
			completeCallBack(this.win);
			return;
		}

		var pt = new ParallelActions();
		this.win.symbols.forEach(s => {
			pt.add(callBack => {
				s.showAnim(true);
				this.winTimeoutID = setTimeout(() => {
					callBack();
				}, playTime);
			});
		});

		pt.start(() => {
			isWinTweenComplete = true;
			this.lineWinCancel();
			completeCallBack(this.win);
		});
	}

	lineWinCancel() {
		if (this.win !== null && this.win.symbols !== null) {
			this.win.symbols.forEach(ws => {
				if (ws !== null) ws.showAnim(false);
			});
		}
		if (this.winTimeoutID !== -1) clearTimeout(this.winTimeoutID);
	}
}
